// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"8619f29f","80":"4db4054d","298":"5665665f","522":"d7bee400","730":"6ba00c3b","813":"243d49ac"}[chunkId] + ".chunk.css";
};